'use es6';

import { Map as ImmutableMap } from 'immutable';
import { deref, unwatch, watch } from 'atom';
import { isResolved } from 'reference-resolvers/utils';
import { listOf } from 'react-immutable-proptypes';
import FilterOperatorType from 'customer-data-filters/components/propTypes/FilterOperatorType';
import PropTypes from 'prop-types';
import PropertyOptionRecord from 'customer-data-objects/property/PropertyOptionRecord';
import { PureComponent } from 'react';
import get from 'transmute/get';
import { jsx as _jsx } from "react/jsx-runtime";
function getFlattenedTeamMap(teams) {
  return teams.reduce((acc, team) => acc.merge({
    [team.get('id')]: team
  }).merge(getFlattenedTeamMap(team.get('childTeams'))), ImmutableMap());
}
export default class DisplayValueTeam extends PureComponent {
  constructor() {
    super();
    this.handleReferenceChange = reference => {
      if (isResolved(reference)) {
        const {
          value
        } = this.props;
        reference = reference.map(team => team.get('referencedObject'));
        this.setState({
          reference: getFlattenedTeamMap(reference).get(String(value))
        });
      }
    };
    this.state = {
      reference: null
    };
    this.referenceAtom = null;
  }
  componentDidMount() {
    const {
      getFamilyValueResolver,
      operator
    } = this.props;
    const resolver = getFamilyValueResolver(operator);
    if (resolver && resolver.all) {
      this.referenceAtom = resolver.all();
      watch(this.referenceAtom, this.handleReferenceChange);
      this.handleReferenceChange(deref(this.referenceAtom));
    }
  }
  componentWillUnmount() {
    if (this.referenceAtom) {
      unwatch(this.referenceAtom, this.handleReferenceChange);
    }
  }
  render() {
    const {
      value,
      specialOptions
    } = this.props;
    const {
      reference
    } = this.state;
    const matchingSpecialOption = specialOptions && specialOptions.find(({
      value: v
    }) => v === value) || {};
    const valueName = matchingSpecialOption.label || matchingSpecialOption.text || get('name', reference) || get('id', reference) || value;
    return /*#__PURE__*/_jsx("span", {
      children: valueName
    });
  }
}
DisplayValueTeam.propTypes = {
  getFamilyValueResolver: PropTypes.func.isRequired,
  operator: FilterOperatorType.isRequired,
  specialOptions: listOf(PropTypes.instanceOf(PropertyOptionRecord).isRequired),
  value: PropTypes.oneOfType([PropTypes.element, PropTypes.node, PropTypes.string]).isRequired
};